import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  styled,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Navigate, useNavigate } from 'react-router-dom';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Vendor = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [showEditVendorModal, setShowEditVendorModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({ vendorId: null, vendorName: '' });
  const [formData, setFormData] = useState({
    vendorCode: '',
    vendorName: '',
    vendorNameArabic: '',
    mobileNo: '',
    email: '',
    trnNo: '',
    countryId: '',
    stateId: '',
    cityId: '',
    poBox: '',
    address: '',
    description: '',
  });

  // Static data for vendors, countries, states, and cities
  const staticVendorData = [
    { vendorId: 1, vendorCode: 'V001', vendorName: 'Vendor One', vendorNameArabic: 'البائع واحد', mobileNo: '1234567890', email: 'vendor.one@example.com', trnNo: 'TRN123', countryId: 1, stateId: 1, cityId: 1, poBox: '12345', address: '123 Main St', description: 'Description for Vendor One' },
    { vendorId: 2, vendorCode: 'V002', vendorName: 'Vendor Two', vendorNameArabic: 'البائع اثنان', mobileNo: '9876543210', email: 'vendor.two@example.com', trnNo: 'TRN456', countryId: 1, stateId: 2, cityId: 2, poBox: '67890', address: '456 Elm St', description: 'Description for Vendor Two' },
    { vendorId: 3, vendorCode: 'V003', vendorName: 'Vendor Three', vendorNameArabic: 'البائع ثلاثة', mobileNo: '5551234567', email: 'vendor.three@example.com', trnNo: 'TRN789', countryId: 1, stateId: 1, cityId: 1, poBox: '54321', address: '789 Oak St', description: 'Description for Vendor Three' },
    { vendorId: 4, vendorCode: 'V004', vendorName: 'Vendor Four', vendorNameArabic: 'البائع أربعة', mobileNo: '4449876543', email: 'vendor.four@example.com', trnNo: 'TRN321', countryId: 1, stateId: 2, cityId: 2, poBox: '98765', address: '321 Pine St', description: 'Description for Vendor Four' },
    { vendorId: 5, vendorCode: 'V005', vendorName: 'Vendor Five', vendorNameArabic: 'البائع خمسة', mobileNo: '7776665555', email: 'vendor.five@example.com', trnNo: 'TRN654', countryId: 1, stateId: 1, cityId: 1, poBox: '13579', address: '654 Cedar St', description: 'Description for Vendor Five' },
    { vendorId: 6, vendorCode: 'V006', vendorName: 'Vendor Six', vendorNameArabic: 'البائع ستة', mobileNo: '3332221111', email: 'vendor.six@example.com', trnNo: 'TRN987', countryId: 1, stateId: 2, cityId: 2, poBox: '24680', address: '987 Birch St', description: 'Description for Vendor Six' },
  ];
const navigate=useNavigate()
  const staticCountryData = [
    { countryId: 1, countryName: 'India' },
  ];

  const staticStateData = [
    { stateId: 1, stateName: 'Bihar' },
    { stateId: 2, stateName: 'Jharkhand' },
  ];

  const staticCityData = [
    { cityId: 1, cityName: 'Patna' },
    { cityId: 2, cityName: 'Ranchi' },
  ];

  const handleAddVendor = () => {
    setFormData({
      vendorCode: '',
      vendorName: '',
      vendorNameArabic: '',
      mobileNo: '',
      email: '',
      trnNo: '',
      countryId: '',
      stateId: '',
      cityId: '',
      poBox: '',
      address: '',
      description: '',
    });
    setShowAddVendorModal(true);
  };

  const handleEdit = (vendor) => {
    setSelectedVendor({ vendorId: vendor.vendorId, vendorName: vendor.vendorName });
    setFormData({
      vendorCode: vendor.vendorCode,
      vendorName: vendor.vendorName,
      vendorNameArabic: vendor.vendorNameArabic,
      mobileNo: vendor.mobileNo,
      email: vendor.email,
      trnNo: vendor.trnNo,
      countryId: vendor.countryId,
      stateId: vendor.stateId,
      cityId: vendor.cityId,
      poBox: vendor.poBox,
      address: vendor.address,
      description: vendor.description,
    });
    setShowEditVendorModal(true);
  };

  const handleDelete = (vendorId, vendorName) => {
    setSelectedVendor({ vendorId, vendorName });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
     setSnackbarMessage('Deleted successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (
      !formData.vendorCode ||
      !formData.vendorName ||
      !formData.mobileNo ||
      !formData.email ||
      !formData.trnNo ||
      !formData.countryId ||
      !formData.stateId ||
      !formData.cityId ||
      !formData.poBox ||
      !formData.address
    ) {
      alert('Please fill all fields');
      return;
    }
    setSnackbarMessage('Vendor Added Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowAddVendorModal(false);
    setFormData({
      vendorCode: '',
      vendorName: '',
      vendorNameArabic: '',
      mobileNo: '',
      email: '',
      trnNo: '',
      countryId: '',
      stateId: '',
      cityId: '',
      poBox: '',
      address: '',
      description: '',
    });
  };

  const handleUpdate = () => {
    if (
      !formData.vendorCode ||
      !formData.vendorName ||
      !formData.mobileNo ||
      !formData.email ||
      !formData.trnNo ||
      !formData.countryId ||
      !formData.stateId ||
      !formData.cityId ||
      !formData.poBox ||
      !formData.address
    ) {
      alert('Please fill all fields');
      return;
    }
    setSnackbarMessage('Vendor Updated Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowEditVendorModal(false);
  };

  const handleReset = () => {
    setFormData({
      vendorCode: '',
      vendorName: '',
      vendorNameArabic: '',
      mobileNo: '',
      email: '',
      trnNo: '',
      countryId: '',
      stateId: '',
      cityId: '',
      poBox: '',
      address: '',
      description: '',
    });
  };

  const handleCancel = () => {
    setShowEditVendorModal(false);
  };

  const filteredData = staticVendorData.filter((vendor) =>
    vendor.vendorCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.vendorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.mobileNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.address.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
       <TextField
                                  variant="outlined"
                                  placeholder="Search..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon
                                          sx={{
                                            color: theme.palette.primary.main,
                                            marginLeft: 1.5,
                                            fontSize: 24,
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                    endAdornment: searchTerm && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => setSearchTerm('')}
                                          sx={{
                                            color: "grey",
                                            marginRight: 1,
                                          }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                    sx: {
                                      borderRadius: '30px',
                                      backgroundColor: theme.palette.mode === 'dark'
                                        ? 'rgba(255, 255, 255, 0.15)'
                                        : 'rgba(255, 255, 255, 1)',
                                      boxShadow: theme.palette.mode === 'dark'
                                        ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                        : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                      },
                                      '&:hover': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.2)'
                                          : 'rgba(240, 240, 240, 1)',
                                        boxShadow: theme.palette.mode === 'dark'
                                          ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                          : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                      },
                                      '&.Mui-focused': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.25)'
                                          : 'rgba(255, 255, 255, 1)',
                                        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          border: `2px solid ${theme.palette.primary.main}`,
                                        },
                                      },
                                      paddingLeft: 1.5,
                                      height: '50px',
                                      transition: 'all 0.3s ease',
                                    },
                                  }}
                                  sx={{
                                    width: 350,
                                    maxWidth: '100%',
                                    '& .MuiInputBase-input': {
                                      padding: '10px 14px',
                                      color: theme.palette.text.primary,
                                      fontWeight: 500,
                                    },
                                  }}
                                />
        <Button
          variant="contained"
          onClick={()=>{navigate('/add-vendor')}}
          sx={{
            ml: 2,
            width: "150px",
            height: "50px",
            borderRadius: "10px",
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD VENDOR
        </Button>
        </Box>
         <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
  <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
    <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
      <Table
        sx={{
          '& .MuiTableHead-root .MuiTableCell-root': {
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Vendor Code</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Vendor Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Mobile No.</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Email</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Address</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData.length > 0 ? (
            paginatedData.map((vendor, index) => (
              <TableRow
                key={vendor.vendorId}
                sx={{
                  backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{vendor.vendorCode}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{vendor.vendorName}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{vendor.mobileNo}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{vendor.email}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{vendor.address}</TableCell>
                <TableCell align="center">
                  <IconButton
                    onClick={() => navigate(`/edit-vendor/${vendor.vendorId}`)}
                    sx={{
                      color: theme.palette.primary.light,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(vendor.vendorId, vendor.vendorName)}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow
              sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell colSpan={7} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </CustomTableScrollbar>
</Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedVendor.vendorName}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showAddVendorModal} onClose={() => setShowAddVendorModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Vendor
            </Typography>
            <IconButton onClick={() => setShowAddVendorModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Vendor Code"
                variant="outlined"
                fullWidth
                name="vendorCode"
                value={formData.vendorCode}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Vendor Name"
                variant="outlined"
                fullWidth
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Vendor Name (Arabic)"
                variant="outlined"
                fullWidth
                name="vendorNameArabic"
                value={formData.vendorNameArabic}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Mobile No."
                variant="outlined"
                fullWidth
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="TRN No."
                variant="outlined"
                fullWidth
                name="trnNo"
                value={formData.trnNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="country-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Country
                </InputLabel>
                <Select
                  labelId="country-label"
                  id="country"
                  name="countryId"
                  value={formData.countryId}
                  label="Country"
                  onChange={handleChange}
                >
                  {staticCountryData.map((countryItem) => (
                    <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                      {countryItem.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="state-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  State
                </InputLabel>
                <Select
                  labelId="state-label"
                  id="state"
                  name="stateId"
                  value={formData.stateId}
                  label="State"
                  onChange={handleChange}
                >
                  {staticStateData.map((stateItem) => (
                    <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                      {stateItem.stateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="city-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  City
                </InputLabel>
                <Select
                  labelId="city-label"
                  id="city"
                  name="cityId"
                  value={formData.cityId}
                  label="City"
                  onChange={handleChange}
                >
                  {staticCityData.map((cityItem) => (
                    <MenuItem key={cityItem.cityId} value={cityItem.cityId}>
                      {cityItem.cityName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="PO Box"
                variant="outlined"
                fullWidth
                name="poBox"
                value={formData.poBox}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Address"
                variant="outlined"
                fullWidth
                name="address"
                value={formData.address}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Description"
                variant="outlined"
                fullWidth
                name="description"
                value={formData.description}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.vendorCode ? 'Enter Vendor Code' :
                  !formData.vendorName ? 'Enter Vendor Name' :
                  !formData.mobileNo ? 'Enter Mobile No.' :
                  !formData.email ? 'Enter Email' :
                  !formData.trnNo ? 'Enter TRN No.' :
                  !formData.countryId ? 'Select Country' :
                  !formData.stateId ? 'Select State' :
                  !formData.cityId ? 'Select City' :
                  !formData.poBox ? 'Enter PO Box' :
                  !formData.address ? 'Enter Address' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={
                    !formData.vendorCode ||
                    !formData.vendorName ||
                    !formData.mobileNo ||
                    !formData.email ||
                    !formData.trnNo ||
                    !formData.countryId ||
                    !formData.stateId ||
                    !formData.cityId ||
                    !formData.poBox ||
                    !formData.address
                  }
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showEditVendorModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Vendor
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Vendor Code"
                variant="outlined"
                fullWidth
                name="vendorCode"
                value={formData.vendorCode}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Vendor Name"
                variant="outlined"
                fullWidth
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Vendor Name (Arabic)"
                variant="outlined"
                fullWidth
                name="vendorNameArabic"
                value={formData.vendorNameArabic}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Mobile No."
                variant="outlined"
                fullWidth
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="TRN No."
                variant="outlined"
                fullWidth
                name="trnNo"
                value={formData.trnNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="country-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Country
                </InputLabel>
                <Select
                  labelId="country-label"
                  id="country"
                  name="countryId"
                  value={formData.countryId}
                  label="Country"
                  onChange={handleChange}
                >
                  {staticCountryData.map((countryItem) => (
                    <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                      {countryItem.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="state-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  State
                </InputLabel>
                <Select
                  labelId="state-label"
                  id="state"
                  name="stateId"
                  value={formData.stateId}
                  label="State"
                  onChange={handleChange}
                >
                  {staticStateData.map((stateItem) => (
                    <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                      {stateItem.stateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth sx={{ my: 2 }}>
                <InputLabel id="city-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  City
                </InputLabel>
                <Select
                  labelId="city-label"
                  id="city"
                  name="cityId"
                  value={formData.cityId}
                  label="City"
                  onChange={handleChange}
                >
                  {staticCityData.map((cityItem) => (
                    <MenuItem key={cityItem.cityId} value={cityItem.cityId}>
                      {cityItem.cityName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="PO Box"
                variant="outlined"
                fullWidth
                name="poBox"
                value={formData.poBox}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Address"
                variant="outlined"
                fullWidth
                name="address"
                value={formData.address}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
              <TextField
                label="Description"
                variant="outlined"
                fullWidth
                name="description"
                value={formData.description}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.vendorCode ? 'Enter Vendor Code' :
                  !formData.vendorName ? 'Enter Vendor Name' :
                  !formData.mobileNo ? 'Enter Mobile No.' :
                  !formData.email ? 'Enter Email' :
                  !formData.trnNo ? 'Enter TRN No.' :
                  !formData.countryId ? 'Select Country' :
                  !formData.stateId ? 'Select State' :
                  !formData.cityId ? 'Select City' :
                  !formData.poBox ? 'Enter PO Box' :
                  !formData.address ? 'Enter Address' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={
                    !formData.vendorCode ||
                    !formData.vendorName ||
                    !formData.mobileNo ||
                    !formData.email ||
                    !formData.trnNo ||
                    !formData.countryId ||
                    !formData.stateId ||
                    !formData.cityId ||
                    !formData.poBox ||
                    !formData.address
                  }
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Vendor Management - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: Search Vendors */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to search for vendors:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              In the search bar at the top left, enter a keyword related to the vendor’s code, name, mobile number, email, or address.
            </li>
            <li>
              The table will automatically filter to display only the vendors matching the search term.
            </li>
            <li>
              Clear the search bar to view all vendors again.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The search is case-insensitive and matches partial text in the specified fields.
          </Typography>

          {/* Section 2: Add a Vendor */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to add a vendor:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Click the <strong>"ADD VENDOR"</strong> button at the top left to navigate to the Add Vendor page.
            </li>
            <li>
              Fill in all required fields: Vendor Code, Vendor Name, Mobile No., Email, TRN No., Country, State, City, PO Box, and Address. The Vendor Name (Arabic) and Description fields are optional.
            </li>
            <li>Befor clicking on SAVE button first ensure all required fields are filled out correctly</li>
            <li>
             Then click the <strong>"SAVE"</strong> button to add the vendor.
            </li>
            <li>
              If any required field is missing, an alert will prompt you to fill all fields.
            </li>
            <li>
              Upon successful addition, a success message will appear, and the form will close.
            </li>
            <li>
            If you wnat to reset the form, then click the <strong>"RESET"</strong> button to clear all form fields if needed.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: All fields except Vendor Name (Arabic) and Description are required to save a vendor.
          </Typography>

          {/* Section 3: Edit a Vendor */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to update a vendor:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              In the vendor table, select the vendor whose record you want to edit/update.
            </li>
            <li>
              Click the <strong>Edit</strong> icon (pencil) in the Action column for the desired vendor.
            </li>
            <li>
              You will be navigated to the Edit Vendor page, where the form will be populated with the vendor’s details.
            </li>
            <li>
              You can update vendor’s details by modifying the fields in the Edit Vendor form a/c to your requirements. Make sure to fill all required fields before clicking "UPDATE".
            </li>
            <li>
              Click the <strong>"UPDATE"</strong>  button to save changes.
            </li>
            <li>
              If any required field is missing, an alert message will display to you to fill all  required fields.
            </li>
            <li>
             If you want to cancel,then click the <strong>"CANCEL"</strong> button to discard changes and close the form.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: All fields except Vendor Name (Arabic) and Description are required to update a vendor.
          </Typography>

          {/* Section 4: Delete a Vendor */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to delete a vendor:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              In the vendor table,select the vendor whose record you want to delete.
            </li>
            <li>
              Click the <strong>Delete</strong> icon button in the Action column for the desired vendor.
            </li>
            <li>
              A confirmation modal will appear, asking you to confirm the deletion.
            </li>
            <li>
              Click <strong>"Yes, Delete"</strong> to remove this  vendor details, or <strong>"Cancel"</strong> to close the modal without deleting.
            </li>
            
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Deleting a vendor is permanent and cannot be undone.
          </Typography>

          {/* Section 5: Navigate the Vendor List */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the vendor list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of vendors.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page. If no vendors match the search term, "No Data Found" will be displayed.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained" 
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default Vendor;